import { createPortal } from "react-dom";

export default function DeactivateStaffModal({
  isOpen,
  staff,
  loading,
  error,
  onClose,
  onConfirm,
}) {
  if (!isOpen || !staff) return null;

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4">
      <div className="w-full max-w-md rounded-3xl bg-white shadow-2xl">
        <div className="flex items-start justify-between border-b border-slate-200 px-6 py-5">
          <div>
            <h2 className="text-xl font-semibold text-slate-900">
              Deactivate Staff
            </h2>
            <p className="mt-1 text-sm text-slate-500">
              This staff account will no longer be able to access the portal.
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="rounded-full p-2 text-2xl leading-none text-slate-500 hover:bg-slate-100"
          >
            ✕
          </button>
        </div>

        <div className="space-y-4 px-6 py-6">
          <div className="rounded-2xl bg-slate-50 p-4">
            <p className="text-sm text-slate-500">Staff Member</p>
            <p className="mt-1 text-base font-semibold text-slate-900">
              {staff.first_name} {staff.last_name}
            </p>
            <p className="mt-1 text-sm text-slate-500">{staff.staff_id}</p>
          </div>

          <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-700">
            Are you sure you want to deactivate this staff account?
          </div>

          {error ? (
            <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-600">
              {error}
            </div>
          ) : null}
        </div>

        <div className="flex justify-end gap-3 border-t border-slate-200 px-6 py-5">
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="rounded-xl border border-slate-300 px-5 py-3 text-sm font-medium text-slate-700 hover:bg-slate-50 disabled:opacity-60"
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className="inline-flex items-center justify-center gap-2 rounded-xl bg-red-600 px-5 py-3 text-sm font-medium text-white hover:bg-red-700 disabled:opacity-60"
          >
            {loading && (
              <span className="h-4 w-4 animate-spin rounded-full border-2 border-white/40 border-t-white" />
            )}
            {loading ? "Deactivating..." : "Deactivate Staff"}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}